import React, { useEffect, useRef, useState } from "react";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { getAllDetails, getSpecificDetails, postAllData } from "../../service/ProductService";
import { GET_SUB_CONTRACTOR_DATA_BY_ID, GET_SUB_CONTRACTOR_PAYMENT_INVOICE_DETAIL, UPDATE_SUB_CONTRACTOR_PDF } from "../../config/ApiConstant";
import { validateSubContractorPayment } from "../../config/Validate";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { convertDateFrom } from "../../appconfig/AppHelper";
import { InputNumber } from "primereact/inputnumber";
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from "primereact/checkbox";
import moment from "moment";
import Loader from "../../components/Loader/Loader";
import { Skeleton } from "primereact/skeleton";

const EditSubContractorPayment = () => {
  document.title = "Invoice | Nexawage";

  const navigate = useNavigate();
  const { payeeId } = useParams();

  const payee_id = payeeId ? atob(payeeId) : null;

  // taken is from state for user loged in
  const location: any = useLocation();
  const clientIdState = location?.state?.id;

  //   client id
  const clientIdByUser = location?.state?.clientId;

  //   sub contractor id
  const subContractorId = location?.state?.sub_contractor_id;

  const [pageLoad, setPageLoad] = useState<boolean>(true);
  //Loading/Page Loading
  const [loading, setLoading] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>({});
  const toast = useRef<any>(null);

  // service table - used to align the total quantity label under the Quantity/Hour column
  const serviceTableRef = useRef<HTMLDivElement>(null);
  const [qtyColPosition, setQtyColPosition] = useState<{ left: number; width: number }>({ left: 0, width: 0 });

  // set send mail loading
  const [sendMailLoading, setSendMailLoading] = useState<boolean>(false);

  // disable btn
  const [disableBtn, setDisableBtn] = useState<boolean>(false);

  //   bill to information
  const [paymentToInformation, setPaymentToInformation] = useState<any>({ bonus: 0, deduction: 0 });

  //   sub contractor detail
  const [subContractorDetail, setSubContractorDetail] = useState<any>({});

  // payment data
  const [paymentDate, setPaymentDate] = useState<Date | null | string | any>();

  // payment invoice url
  const [paymentInvoiceUrl, setPaymentInvoiceUrl] = useState<any>(null);

  //Item Array
  const [serviceItemArray, setServiceItemArray] = useState<any[string | Number | Number | any | Number]>([
    {
      name: "Gross Pay",
      hour: "",
      rate: "",
      amount: 0.0,
    },
  ]);

  //   calculation state
  const [gstTax, setGstTax] = useState<any>(5);

  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;
  const userRole = userData?.roles?.role_name || "";
  let clientId: any = null;

  if (userRole === "User") {
    clientId = clientIdByUser;
  } else {
    clientId = userData?.id;
  }

  //   Date Object
  const today = new Date();
  const [dates, setDates] = useState<String | Date | Date[] | null | any>(today);

  // period start date
  const [startDate, setStartDate] = useState<String | Date | Date[] | null | any>(null);

  // selected payee
  const [selectedSubContractor, setSelectedSubContractor] = useState<any>();

  useEffect(() => {
    onHandleChangeSubContractor(payee_id);
    getSubContractorPaymentDataForEdit();
  }, []);

  // on payee selected
  const onHandleChangeSubContractor = async (e: any) => {
    // setSelectedSubContractor(e.value);
    setSelectedSubContractor(payee_id);

    const result = await getAllDetails(`${GET_SUB_CONTRACTOR_DATA_BY_ID}/${payee_id}`);

    if (result) {
      // setPayeeDetails(result);
      setPaymentToInformation(result);
    }
  };

  // get sub contractor payment detail for edit invoice
  const getSubContractorPaymentDataForEdit = async () => {
    try {
      const response = await getAllDetails(`${GET_SUB_CONTRACTOR_PAYMENT_INVOICE_DETAIL}/${clientIdState}`);

      if (response) {
        let itemDetail = response?.sub_payment_line_item;
        let itemDetailArray: {
          id: any;
          name: any;
          hour: any;
          rate: any;
          amount: any;
        }[] = [];

        itemDetail.map((item: any, index: number) => {
          itemDetailArray.push({
            id: item.id,
            name: item.name,
            hour: item.hour,
            amount: item.amount,
            rate: item.rate,
          });
        });

        setServiceItemArray(itemDetailArray);

        // sub contractor detail
        let contractorData = response?.contractor_data;
        if (contractorData) {
          setSubContractorDetail({
            id: contractorData?.id,
            address: contractorData?.address,
            client_id: contractorData?.client_id,
            email: contractorData?.email,
            name: contractorData?.name,
            phone: contractorData?.phone,
          });
        }

        // sub contractor calculation detail
        if (response) {
          setPaymentToInformation({
            ...paymentToInformation,
            payment_mode: response?.payment_mode,
            gst_added: response?.gst_added,
            bonus: response?.bonus,
            deduction: response?.deduction,
            deduction_notes: response?.deduction_notes,
            notes: response?.notes,
            show_ytd_deduction: response?.show_ytd_deduction == 1 || response?.show_ytd_deduction === true,
          });

          //   set period end date — strip time/tz before parsing to avoid UTC-to-local day shift
          setDates(moment(response?.date?.substring(0, 10), "YYYY-MM-DD").toDate());

          //   set period start date — strip time/tz before parsing to avoid UTC-to-local day shift
          if (response?.start_date) {
            setStartDate(moment(response?.start_date?.substring(0, 10), "YYYY-MM-DD").toDate());
          }

          //   set payment date
          setPaymentDate(response?.payment_date?.substring(0, 10) ?? null);
          setPageLoad(false);
        }
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
    }
  };

  //onchange event
  const onInputChange = (e: any, name: string) => {
    let val: any;

    if (name === "show_ytd_deduction") {
      val = e.checked;
    } else {
      val = (e.target && e.target.value) !== undefined ? e.target.value : e.value || "";
    }

    setPaymentToInformation({ ...paymentToInformation, [name]: val });
    // Clear errors safely
    setErrors((prev: any) => {
      const updatedErrors = { ...prev, [name]: "" };

      // If deduction is string remove deduction_notes error
      if (name === "deduction" && typeof val === "string") {
        updatedErrors.deduction_notes = "";
      }

      return updatedErrors;
    });

    // if deduction is empty then deduction_notes should be null
    if (name === "deduction" && typeof val === "string") {
      setPaymentToInformation((prev: any) => ({
        ...prev,
        deduction_notes: null,
      }));
    }
  };

  //   on radio button change
  const onInputChangeRadio = (e: any, name: any) => {
    setPaymentToInformation((prev: any) => ({
      ...prev,
      [name]: e.value,
    }));
  };

  // on payment date change
  const onPaymentDateChange = (e: any) => {
    let val;
    let dateVal;
    val = e?.target?.value ?? e?.value;
    dateVal = moment(val).format("YYYY-MM-DD");
    setPaymentDate(dateVal);
    setErrors({});
  };

  //   onDate change
  const onDateChange = (e: any) => {
    setDates(e.value);
  };

  //   onStartDate change
  const onStartDateChange = (e: any) => {
    setStartDate(e.value);
  };

  const clearAll = (e: any) => {
    setPaymentToInformation({
      name: [paymentToInformation?.name],
      email: [paymentToInformation?.email],
      phone: [paymentToInformation?.phone],
      address: [paymentToInformation?.address],
    });
    setPaymentDate(null);
    setGstTax(5);
    setServiceItemArray([
      {
        name: "Gross Pay",
        quantity: "",
        rate: "",
        amount: 0.0,
      },
    ]);
    setErrors({});
  };

  // remove service row
  const removeRowTemplate = (_: any, { rowIndex }: any) => {
    if (serviceItemArray.length === 1) {
      return " - ";
    } else {
      return (
        <>
          <Button icon="pi pi-trash" className="p-button-danger p-button-rounded " onClick={() => handleRemoveRow(rowIndex)} />
        </>
      );
    }
  };

  //   remove service row index
  const handleRemoveRow = (index: number) => {
    const updatedRows = [...serviceItemArray];
    updatedRows.splice(index, 1);
    setServiceItemArray(updatedRows);
  };

  //total sum calculation
  const getTotal = () => {
    let subTotal: any = 0;
    let totalAmount: any = 0;
    let totalGst: any = 0;
    let totalbonus: any = paymentToInformation.bonus ? Number(paymentToInformation?.bonus) : 0;
    let totaldeduction: any = paymentToInformation.deduction ? Number(paymentToInformation?.deduction) : 0;

    // Check service detail hour and rate
    serviceItemArray.forEach((item: any) => {
      let hour = parseFloat(item.hour) || 0;
      let rate = parseFloat(item.rate) || 0;

      let itemSubTotal = hour * rate;

      // Accumulate totals
      subTotal += itemSubTotal;
    });

    // subtotal + bonus
    subTotal = subTotal + totalbonus;

    // total gst if gst_added is yes
    totalGst = paymentToInformation.gst_added == true ? (gstTax * subTotal) / 105 : 0;

    // total Amount
    totalAmount = subTotal - totaldeduction;

    return {
      subTotal: subTotal.toFixed(2),
      totalGst: totalGst,
      totalAmount: totalAmount.toFixed(2),
    };
  };

  //add Amount
  const amountTemplate = (rowData: any, { rowIndex }: any) => {
    return (
      <InputText
        type="number"
        value={parseFloat(rowData.amount).toFixed(2)}
        name="amount"
        autoComplete="off"
        style={{ minWidth: "100px", textAlign: "right" }}
        disabled
      />
    );
  };

  //on submit api call
  const onPaymentFormSubmit = async (type: any = null) => {
    try {
      const { errors, isError } = validateSubContractorPayment(paymentToInformation, dates, paymentDate, serviceItemArray);
      setErrors(errors);

      //Check Error if no errors then call API
      if (!isError) {
        if (type === "sendMail") {
          setSendMailLoading(true);
        } else {
          setLoading(true);
        }
        setDisableBtn(true);

        //Request object
        const payload = {
          id: clientIdState,
          sub_contractor_id: subContractorId,
          client_id: clientId,
          notes: paymentToInformation?.notes,
          show_ytd_deduction: paymentToInformation?.show_ytd_deduction ? 1 : 0,
          gst_added: paymentToInformation?.gst_added === true ? "1" : "0",
          payment_mode: paymentToInformation?.payment_mode,
          payment_date: convertDateFrom(paymentDate),
          deduction: paymentToInformation.deduction ? paymentToInformation?.deduction : 0,
          ...{ deduction_notes: paymentToInformation?.deduction ? paymentToInformation?.deduction_notes : null },
          ...(startDate && { start_date: convertDateFrom(startDate) }),
          date: convertDateFrom(dates),
          bonus: paymentToInformation.bonus ? paymentToInformation?.bonus : 0,
          ...(type === "sendMail" && { send_mail: "1" }),

          sub_line_item: serviceItemArray,
        };

        //apicall
        const response = await postAllData(UPDATE_SUB_CONTRACTOR_PDF, payload);

        if (response) {
          toast.current?.show({
            severity: "success",
            summary: "Success",
            detail: response.message,
          });
          if (type === "sendMail") {
            setSendMailLoading(false);
            setDisableBtn(false);
          } else {
            setLoading(false);
            setDisableBtn(false);
          }
          window.open(response?.data, "_blank");
          setPaymentInvoiceUrl(response?.data);

          navigate("/sub-contractor-payment", {
            state: { clientId: clientId },
          });
        }
      }
    } catch (error: any) {
      if (type === "sendMail") {
        setSendMailLoading(false);
        setDisableBtn(false);
      } else {
        setLoading(false);
        setDisableBtn(false);
      }
      toast.current?.show({
        severity: "error",
        summary: "Alert",
        detail: error?.response?.data?.message,
      });
    }
  };

  //add multiple service data
  const handleItemArray = () => {
    setServiceItemArray([...serviceItemArray, { name: "Gross Pay", hour: "", rate: "", amount: 0.0 }]);
  };

  // service Item Change
  const onServiceItemChange = (e: any, name: string, index: number) => {
    let tempSerciceItemArray = [...serviceItemArray];
    tempSerciceItemArray[index][name] = e.target.value || e.value;
    tempSerciceItemArray[index].amount = (parseFloat(tempSerciceItemArray[index].hour) || 0) * (parseFloat(tempSerciceItemArray[index].rate) || 0);

    setServiceItemArray(tempSerciceItemArray);
    setErrors((prev: any) => ({ ...prev, [`${name}_${index}`]: "" }));
  };

  // hour/Rate change
  const onQuantityRateChange = (e: any, name: string, index: number) => {
    let tempItemArray = [...serviceItemArray];
    tempItemArray[index][name] = e?.target?.value ?? e?.value;
    tempItemArray[index].amount = (parseFloat(tempItemArray[index].hour) || 0) * (parseFloat(tempItemArray[index].rate) || 0);

    setServiceItemArray(tempItemArray);
    setErrors((prev: any) => ({ ...prev, [`${name}_${index}`]: "" }));
  };

  // InputNumber's own paste parser can't strip a "$" in decimal mode, so handle pasted amounts (e.g. copied from a sheet) manually
  const onQuantityRatePaste = (e: any, name: string, index: number) => {
    const pasted = e.clipboardData?.getData("text") || "";
    const sanitized = parseFloat(pasted.replace(/[^0-9.-]/g, ""));
    if (!isNaN(sanitized)) {
      onQuantityRateChange({ value: sanitized }, name, index);
    }
  };

  // total quantity/hour across all service rows
  const getTotalQuantity = () => {
    return serviceItemArray.reduce((sum: number, item: any) => sum + (parseFloat(item.hour) || 0), 0);
  };

  // measure the Quantity/Hour column's actual rendered position so the total stays aligned under it
  const measureQtyColumn = () => {
    const container = serviceTableRef.current;
    const qtyHeader = container?.querySelector(".qty-col-header") as HTMLElement | null;
    if (!container || !qtyHeader) return;
    const containerRect = container.getBoundingClientRect();
    const qtyRect = qtyHeader.getBoundingClientRect();
    setQtyColPosition({ left: qtyRect.left - containerRect.left, width: qtyRect.width });
  };

  useEffect(() => {
    measureQtyColumn();
    window.addEventListener("resize", measureQtyColumn);
    return () => window.removeEventListener("resize", measureQtyColumn);
  }, [serviceItemArray, pageLoad]);

  //add Service item
  const addServiceItemTemplate = (rowData: any, { rowIndex }: any) => {
    return (
      <>
        <div className="input-effect-div">
          <InputText
            value={rowData?.name || ""}
            name="name_"
            autoComplete="off"
            onChange={(e) => onServiceItemChange(e, "name", rowIndex)}
            className={errors[`name_${rowIndex}`] && "p-invalid"}
            style={{ minWidth: "100px" }}
            placeholder="Enter Service Name"
          />
          <span className="focus-bg"></span>
        </div>
        <small className="p-invalid-txt">{errors[`name_${rowIndex}`]}</small>
      </>
    );
  };

  //add Quantity
  const QtyTemplate = (rowData: any, { rowIndex }: any) => {
    return (
      <>
        <div className="input-effect-div">
          <form autoComplete="off">
            <InputNumber
              // keyfilter={"int"}
              value={!window.cn(rowData.hour) ? rowData?.hour : ""}
              name="hour_"
              onChange={(e) => onQuantityRateChange(e, "hour", rowIndex)}
              onPaste={(e: any) => onQuantityRatePaste(e, "hour", rowIndex)}
              className={errors[`hour_${rowIndex}`] && "p-invalid"}
              style={{ minWidth: "100px" }}
              placeholder="0.00"
              // minFractionDigits={2}
              maxFractionDigits={2}
              inputStyle={{ appearance: "none", MozAppearance: "textfield" }}
              mode="decimal"
              useGrouping={false}
            />
          </form>
          <span className="focus-bg"></span>
        </div>
        <small className="p-invalid-txt">{errors[`hour_${rowIndex}`]}</small>
      </>
    );
  };

  //add rate
  const rateTemplate = (rowData: any, { rowIndex }: any) => {
    return (
      <>
        <form autoComplete="off">
          <div className="flex-1 input-effect-div p-inputgroup">
            <InputNumber
              value={!window.cn(rowData.rate) ? rowData?.rate : ""}
              name="rate_"
              onChange={(e) => onQuantityRateChange(e, "rate", rowIndex)}
              onPaste={(e: any) => onQuantityRatePaste(e, "rate", rowIndex)}
              className={errors[`rate_${rowIndex}`] && "p-invalid"}
              // minFractionDigits={2}
              maxFractionDigits={2}
              style={{ minWidth: "100px" }}
              mode="decimal"
              placeholder="0.00"
              useGrouping={false}
            />
            <span className="font-bold p-inputgroup-addon">$</span>
          </div>
          <small className="p-invalid-txt">{errors[`rate_${rowIndex}`]}</small>
        </form>
      </>
    );
  };

  return (
    <>
      <AppBreadcrumb currentMenu="Payment" pageName="Form" pageTitle="Payment" goToPage={true} />

      <div className="grid crud-demo">
        <div className="col-12">
          <Card className="bg-white crud-demo lg:p-2 relative">
            <Toast ref={toast} />

            {!pageLoad ? (
              <>
                <div className="p-fluid formgrid grid">
                  <div className="field col-12">
                    <h4 className="mb-0">Payment To Information</h4>
                  </div>

                  {/* Bill To */}
                  <div className="field col-12 md:col-4">
                    <label htmlFor="bill_to">Name *</label>
                    <div className="input-effect-div">
                      <InputText
                        value={subContractorDetail?.name || ""}
                        autoComplete="off"
                        id="name"
                        disabled={true}
                        placeholder="Enter Bill To"
                        onChange={(e) => onInputChange(e, "name")}
                        className={errors["name"] && "p-invalid"}
                      />
                      <small className="p-invalid-txt">{errors["name"]}</small>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="field col-12 md:col-4">
                    <label htmlFor="email">Email </label>
                    <div className="input-effect-div">
                      <InputText
                        value={subContractorDetail?.email || ""}
                        autoComplete="off"
                        id="email"
                        disabled={true}
                        placeholder="Enter Email"
                        onChange={(e) => onInputChange(e, "email")}
                        className={errors["email"] && "p-invalid"}
                      />
                      <small className="p-invalid-txt">{errors["email"]}</small>
                    </div>
                  </div>

                  {/* Phone Number */}
                  <div className="field col-12 md:col-4">
                    <label htmlFor="bill_phone">Phone Number </label>
                    <div className="flex-1 input-effect-div p-inputgroup">
                      <span className="font-bold p-inputgroup-addon">+1</span>
                      <InputText
                        value={subContractorDetail.phone || ""}
                        name="phone"
                        autoComplete="off"
                        disabled={true}
                        placeholder="Enter Phone Number"
                        onChange={(e) => onInputChange(e, "phone")}
                        className={errors["phone"] && "p-invalid"}
                        keyfilter="pint"
                        maxLength={10}
                      />
                      <span className="focus-bg"></span>
                    </div>
                    <small className="p-invalid-txt">{errors["phone"]}</small>
                  </div>

                  {/* Address */}
                  <div className="field col-12 md:col-4">
                    <label htmlFor="bill_address">Address </label>
                    <div className="input-effect-div">
                      <InputTextarea
                        value={subContractorDetail?.address || ""}
                        autoComplete="off"
                        rows={2}
                        id="address"
                        disabled={true}
                        placeholder="Enter Address"
                        onChange={(e) => onInputChange(e, "address")}
                        className={errors["address"] && "p-invalid"}
                      />
                      <small className="p-invalid-txt">{errors["address"]}</small>
                    </div>
                  </div>

                  <div className="field col-12 mt-3">
                    <h4 className="mb-0">Payment Information</h4>
                  </div>

                  {/* Period Start Date */}
                  <div className="field col-12 md:col-4">
                    <label htmlFor="start_date">Period Start Date</label>
                    <Calendar
                      value={startDate}
                      dateFormat="dd/mm/yy"
                      onChange={(e) => onStartDateChange(e)}
                      showIcon
                      placeholder="DD-MM-YYYY"
                    />
                  </div>

                  {/* Date */}
                  <div className="field col-12 md:col-4">
                    <label htmlFor="date">Period End Date *</label>
                    <Calendar
                      value={dates}
                      dateFormat="dd/mm/yy"
                      onChange={(e) => onDateChange(e)}
                      showIcon
                      className={errors["date"] && "p-invalid"}
                    />
                    <small className="p-invalid-txt">{errors["date"]}</small>
                  </div>

                  {/* e transfer date */}
                  <div className="field col-12 md:col-4">
                    <label htmlFor="date">Cheque date / E-transfer date *</label>
                    <div className="input-effect-div">
                      <Calendar
                        value={paymentDate ? moment(paymentDate, "YYYY-MM-DD").toDate() : null}
                        dateFormat="dd/mm/yy"
                        placeholder="Enter E-transfer Date "
                        onChange={(e) => onPaymentDateChange(e)}
                        showIcon
                        className={errors["paymentDate"] && "p-invalid"}
                      />
                    </div>
                    <small className="p-invalid-txt">{errors["paymentDate"]}</small>
                  </div>

                  {/* Payment Method */}
                  <div className="field col-12 md:col-4">
                    <label htmlFor="payment_mode">Payment Method </label>
                    <span className="required">*</span>
                    <div className="flex gap-4 mt-2">
                      <div className="flex align-items-center">
                        <RadioButton
                          inputId="payment_mode"
                          name="payment_mode"
                          value="E-Transfer"
                          onChange={(e) => onInputChange(e, "payment_mode")}
                          checked={paymentToInformation?.payment_mode === "E-Transfer"}
                        />
                        <label htmlFor="married_yes" className="ml-2">
                          E-Transfer
                        </label>
                      </div>
                      <div className="flex align-items-center">
                        <RadioButton
                          inputId="payment_mode"
                          name="payment_mode"
                          value="Cheque"
                          onChange={(e) => onInputChange(e, "payment_mode")}
                          checked={paymentToInformation?.payment_mode === "Cheque"}
                        />
                        <label htmlFor="married_no" className="ml-2">
                          Cheque
                        </label>
                      </div>
                    </div>
                    <small className="p-invalid-txt">{errors["payment_mode"]}</small>
                  </div>

                  {/* gst added or not */}

                  <div className="field col-12 md:col-4">
                    <label>GST Added</label>
                    <span className="required">*</span>

                    <div className="flex gap-4 mt-2">
                      <div className="flex align-items-center">
                        <RadioButton
                          inputId="gst_yes"
                          name="gst_added"
                          value={true}
                          onChange={(e) => onInputChangeRadio(e, "gst_added")}
                          checked={paymentToInformation?.gst_added === true}
                        />
                        <label htmlFor="gst_yes" className="ml-2">
                          Yes
                        </label>
                      </div>

                      <div className="flex align-items-center">
                        <RadioButton
                          inputId="gst_no"
                          name="gst_added"
                          value={false}
                          onChange={(e) => onInputChangeRadio(e, "gst_added")}
                          checked={paymentToInformation?.gst_added === false}
                        />
                        <label htmlFor="gst_no" className="ml-2">
                          No
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* Show YTD Deduction Checkbox */}
                  <div className="field col-12 md:col-6 flex align-items-center mt-3">
                    <Checkbox
                      inputId="show_ytd_deduction"
                      onChange={(e) => onInputChange(e, "show_ytd_deduction")}
                      checked={paymentToInformation?.show_ytd_deduction || false}
                    />
                    <label htmlFor="show_ytd_deduction" className="ml-2 mb-0" style={{ fontSize: "15px" }}>
                      Do you want to show Year to Date deductions in the invoice?
                    </label>
                  </div>

                  <div className="field col-12 mt-3">
                    <h4 className="mb-0">Service Details</h4>
                  </div>

                  {/* service table */}
                  <div className="field col-12 md:col-12" ref={serviceTableRef}>
                    <DataTable value={serviceItemArray} responsiveLayout="scroll" showGridlines>
                      <Column field="name" header="Service Name" body={addServiceItemTemplate} style={{ width: "18%" }} />
                      <Column field="hour" header="Quantity / Hour" headerClassName="qty-col-header" body={QtyTemplate} style={{ width: "18%" }} />
                      <Column field="rate" header="Rate" body={rateTemplate} style={{ width: "18%" }} />
                      <Column field="amount" header="Amount E-transfer / Cheque Amount" body={amountTemplate} style={{ width: "18%" }} />
                      <Column header="Action" body={removeRowTemplate} style={{ width: "6%" }} />
                    </DataTable>
                    {serviceItemArray.length > 1 && (
                      <div style={{ marginLeft: qtyColPosition.left, width: qtyColPosition.width }} className="text-center mt-2">
                        <small className="font-bold">Total Quantity: {getTotalQuantity()}</small>
                      </div>
                    )}
                  </div>

                  <div className="field col-12 md:col-12 grid justify-content-between mb-0">
                    <div className="field col-12 md:col-5 flex flex-column justify-content-between ">
                      <div>
                        <Button icon="pi pi-plus" label="Add New Row" className="p-button" onClick={handleItemArray} style={{ width: "auto" }} />
                      </div>

                      {/* Reference Note */}
                      <div className="mt-5">
                        {" "}
                        <label htmlFor="reference ">Note</label>
                        <div className="input-effect-div mt-2">
                          <InputTextarea
                            value={!window.cn(paymentToInformation.notes) ? paymentToInformation.notes : ""}
                            autoComplete="off"
                            placeholder="Enter Note"
                            id="notes"
                            onChange={(e) => onInputChange(e, "notes")}
                            className={errors["notes"] && "p-invalid"}
                            rows={3}
                          />
                          <span className="focus-bg"></span>
                        </div>
                      </div>

                      {/* Deduction note */}
                      <div className="field mt-3 ">
                        <label htmlFor="deduction_notes">Deduction Remark </label>

                        <div className="input-effect-div">
                          <InputTextarea
                            rows={3}
                            value={paymentToInformation.deduction_notes || ""}
                            name="deduction_notes"
                            autoComplete="off"
                            placeholder="Enter Deduction Remark"
                            onChange={(e) => onInputChange(e, "deduction_notes")}
                            className={errors["deduction_notes"] && "p-invalid"}
                          />
                          <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors["deduction_notes"]}</small>
                      </div>
                    </div>

                    {/* sub Total tax calculation */}
                    <div className="field col-12 md:col-6 total-card p-4 ">
                      {/* Bonus / commission */}
                      <div className="flex justify-content-between mb-4 align-items-center">
                        <div className="flex p-field w-4 align-items-center">
                          <label htmlFor="gst" className="block font-medium mr-5">
                            Bonus / Commission
                          </label>
                        </div>

                        <div>
                          <InputNumber
                            id="gst"
                            value={!window.cn(paymentToInformation.bonus) ? paymentToInformation.bonus : ""}
                            onChange={(e) => onInputChange(e, "bonus")}
                            className={errors["bonus"] && "p-invalid"}
                            placeholder="0.00"
                            // minFractionDigits={2}
                            maxFractionDigits={2}
                            mode="decimal"
                            useGrouping={false}
                          />
                        </div>
                      </div>

                      {/* sub Total */}
                      <div className="flex justify-content-between mb-3 ">
                        <h6 className="mt-0 mb-0">Sub Total</h6>
                        <h6 className="mt-0 mb-0">{`$${getTotal().subTotal}`}</h6>
                      </div>

                      {/* Gst */}
                      <div className="flex justify-content-between mb-4 align-items-center">
                        <div className="flex p-field w-4 align-items-center">
                          <label htmlFor="hst" className="block font-medium mr-7">
                            GST
                          </label>
                        </div>

                        <h6 className="mt-0 mb-0">{`$${getTotal().totalGst.toFixed(2)}`}</h6>
                      </div>

                      <hr />

                      {/* Deduction */}
                      <div className="flex justify-content-between mb-4 align-items-center">
                        <div className="flex p-field w-4 align-items-center">
                          <label htmlFor="gst" className="block font-medium mr-5">
                            Deduction
                          </label>
                        </div>

                        <div className="">
                          <form autoComplete="off">
                            <InputNumber
                              value={!window.cn(paymentToInformation.deduction) ? paymentToInformation.deduction : ""}
                              onChange={(e) => onInputChange(e, "deduction")}
                              placeholder="0.00"
                              name="deduction"
                              className={errors["deduction"] && "p-invalid"}
                              // minFractionDigits={2}
                              maxFractionDigits={2}
                              mode="decimal"
                              useGrouping={false}
                            />
                          </form>
                        </div>
                      </div>

                      <hr />

                      <div className="flex justify-content-between mb-5 align-items-center">
                        <h5 className="block font-bold">Total</h5>
                        <h5 className="mt-0 mb-0">{`$${getTotal().totalAmount}`}</h5>
                      </div>
                    </div>

                    {/* Email Note */}
                    <div style={{ color: "red" }} className="p-2">
                      <span className="text-lg">
                        <b className="font-bold">Note :</b>
                        {` On submit email will be sent to`} <span>{` ${subContractorDetail?.email}`}</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="card-footer flex flex-wrap gap-2 mt-4 md:gap-3 justify-content-end align-items-center">
                  <div className="button-group">
                    <Button
                      label="Cancel"
                      icon="pi pi-times"
                      className="p-button-secondary mr-4"
                      disabled={loading || disableBtn}
                      onClick={clearAll}
                    />
                    <Button label="Submit" icon="pi pi-check" loading={loading} disabled={disableBtn} onClick={onPaymentFormSubmit} />
                    <div className="mt-3 flex justify-content-center">
                      <Button
                        label="Submit & Send Email"
                        icon="pi pi-check"
                        loading={sendMailLoading}
                        disabled={loading || disableBtn}
                        onClick={() => onPaymentFormSubmit("sendMail")}
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <Skeleton height="500px" className="mt-3 mb-3 border-round" />
            )}

            {pageLoad === true && <Loader />}
          </Card>
        </div>
      </div>
    </>
  );
};

export default EditSubContractorPayment;
